import { render, staticRenderFns } from "./Page-header.vue?vue&type=template&id=01041e24&"
import script from "./Page-header.vue?vue&type=script&lang=js&"
export * from "./Page-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports